<template>
  <transition
    name="fade"
    enter-active-class="fadeInUp"
    leave-active-class="fadeOutDown">
    <div
      class="ce-basketActionBar"
      v-if="basketSize > 0">
      <button
        class="ce-btn ce-btn-light"
        @click.prevent="startDownload"
        :disabled="multiDownloadActive">
        <fa-layers
          v-if="!multiDownloadActive">
          <fa-icon
            icon="download" />
          <span class="fa-layers-counter">
            {{ basketSize }}
          </span>
        </fa-layers>
        <fa-layers
          v-else>
          <fa-icon
            icon="spinner"
            spin />

          <span class="fa-layers-counter">
            {{ basketSize }}
          </span>
        </fa-layers>
      </button>

      <MsdsSettingsModal
        v-if="msdsSettingsModalVisible"
        @close="cancelDownload"
        @submit="saveMsdsSettingsAndContinue" />
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import MsdsSettingsModal from 'components/product-sheets/MsdsSettingsModal.vue';

export default {
  components: { MsdsSettingsModal },
  data() {
    return {
      multiDownloadActive: false,
      msdsSettingsModalVisible: false,
    };
  },
  computed: {
    ...mapState(['basket']),
    ...mapGetters(['basketContainsMsdsDocuments', 'basketSize']),
  },
  methods: {
    async startDownload() {
      if (this.basketContainsMsdsDocuments) {
        this.msdsSettingsModalVisible = true;
      } else {
        await this.triggerMultiDownload();
      }
    },
    async saveMsdsSettingsAndContinue(settings) {
      await this.$store.dispatch('saveMsdsSettings', settings);
      this.msdsSettingsModalVisible = false;
      await this.triggerMultiDownload();
    },
    cancelDownload() {
      this.msdsSettingsModalVisible = false;
      this.multiDownloadActive = false;
    },
    async triggerMultiDownload() {
      this.multiDownloadActive = true;

      try {
        await this.$store.dispatch('downloadBasket');
        const noty = this.$notification.success(this.$t('productSheets.zipDownload.successMessage'), {}, false);

        noty.on('onClose', () => {
          this.$store.dispatch('clearBasket');
        });

        noty.show();
      } catch (e) {
        this.$notification.error(e.response?.data?.message ?? e.message);
      }

      this.multiDownloadActive = false;
    }
  }
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';

  .ce-basketActionBar {
    display: flex;
    justify-content: center;
    position: fixed;
    z-index: 9500;
    right: @space-3;
    bottom: @space-3;

    > button {
      border-radius: 50%;
      width: 50px;
      height: 50px;
      padding: 0;

      .fa-layers-counter {
        color: @color-light;
        background: @color-mono-100;
        transform: scale(1) translateX(70%);
        .ms(-3);
        top: -20px;
        right: 0;
        font-weight: 700;
        border: 2px solid @color-light;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 20px;
        height: 20px;
        line-height: 20px;
      }
    }
  }
</style>
